import Checkbox from "../Checkbox";
import styles from "./index.module.css";
import PropTypes from "prop-types";

/**
 * A checkbox with a label. Any elements passed as children will be placed into the label.
 * Sized to fit neatly in a form with other inputs and buttons. All props are passed verbatim
 * to the <Checkbox> component.
 */
export default function CheckboxGroup({ id, children, ...props }) {
  return (
    <div className={styles.group}>
      <Checkbox id={id} {...props} />
      <label htmlFor={id}>{children}</label>
    </div>
  );
}

CheckboxGroup.propTypes = {
  /**
   * A unique ID to identify the checkbox. Required.
   */
  id: PropTypes.string.isRequired,
};
